import { useStore } from '@stores';
import { ISmsTemplateHook } from 'models/Hooks/SmsTemplate';
import { useEffect } from 'react';

declare const abp: any;

export const useSmsTemplates = (): ISmsTemplateHook => {
  const { smsTemplateStore } = useStore();
  const { smsTemplates, loading, submitLoading, smsSenderId, senderIdLoading } = smsTemplateStore;

  useEffect(() => {
    smsTemplateStore.getAll();
    smsTemplateStore.getSmsSenderId();

    return () => smsTemplateStore.clearSmsTemplates();
  }, [smsTemplateStore]);

  return {
    loading,
    submitLoading,
    dataSource: Array.from(smsTemplates.values()),
    smsSenderId,
    senderIdLoading,
  };
};
